export const Paths = {
    Home: { path: "/" },
    NotFound: { path: "/404" },
    ServerError: { path: "/500" },
    About: { path: "/about" },
    Signin: { path: "/signin" },
    Signup: { path: "/signup" },
    Account: { path: "/account" },
    Settings: { path: "/settings" },
    Billing: { path: "/billing" },
    Pricing: { path: "/pricing" },
    Notifications: { path: "/notifications" },
    VerifyEmail: { path: "/verify-email" },
    Terms: {path: "/terms"},
    Privacy: {path: "/privacy"},
    Goodbye: {path: "/goodbye"},
    Blog: {path: "/blog"},
    BlogPosts: {path: "/blog/posts"},
    Workers: {path: "/workers"},
    Worker: {path: "/worker"},
    AddWorker: {path: "/add-worker"},
    Chat: {path: "/chat"},
    ApiKeys: {path: "/api-keys"},
    Deploy: {path: "/deploy"},
    Console: {path: "/workers"},
    DataIndex: {path: "/data-index"},
    DataIndexes: {path: "/data-indexes"},
    CreateDataIndex: {path: "/create-data-index"},
    ChatDataIndex: {path: "/chat-data-index"},
};
